// extracted by mini-css-extract-plugin
export default {"ask":"OrderBook_ask__WwV68","bid":"OrderBook_bid__uPg30","container":"OrderBook_container__1a24m","dynamic-div":"OrderBook_dynamic-div__n4IIQ"};